<template>
    <div class="statusarea" @click.prevent="">
        <span :class="statusCss" :title="statusTitle" />
    </div>
</template>

<style scoped lang="scss">
    .statusarea {
        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .label-success {
        background-color: #5cb85c;
    }
    .label-info {
        background-color: #5bc0de;
    }
    .label-warning {
        background-color: #f0ad4e;
    }
    .label-danger {
        background-color: #d9534f;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { SignalR } from "@/support/SignalR";

export default defineComponent({
    data() {
        return {
            statusTitle: "Site Disconnected",
            css: "label-danger",
        };
    },
    computed: {
        statusCss(): string {
            return `${this.css} position-absolute top-0 start-100 translate-middle p-2 border border-light rounded-circle`;
        },
    },
    mounted(): void {
        SignalR.registerUpdateStatusCallback((css: string, text: string): void => {
            this.statusTitle = text;
            this.css = css;
        });
    },
    unmounted(): void {
        SignalR.registerUpdateStatusCallback(null);
    },
});
</script>
